import { pickQuestionnaireLogoUrl } from "../../../utils/questionnaireBranding";

/**
 * Resolve the client identity displayed in the standalone lab checkout header.
 * This keeps the lab storefront aligned with the rest of the questionnaire
 * checkout surfaces, including the established logo preference order.
 */
export function resolveLabCheckoutBranding(clientConfig) {
  const brandingSources = [
    clientConfig?.questionnaire_config,
    clientConfig?.branding_config,
    clientConfig,
  ].filter((branding) => branding && typeof branding === "object");
  const branding = brandingSources[0] || {};
  const name = brandingSources.find((source) => source.company_name)?.company_name
    || clientConfig?.name
    || "WellieMD";
  const logoUrl = brandingSources
    .map((source) => pickQuestionnaireLogoUrl(source))
    .find(Boolean)
    ?.replace("localstack", "localhost")
    || "";

  return { name, logoUrl };
}

/**
 * Tenant branding is fresher than the control-plane config during a client
 * branding update. Merge it into both supported config shapes so the same
 * logo resolver serves standalone labs immediately.
 */
export function mergeLabCheckoutBranding(clientConfig, tenantBranding) {
  if (!tenantBranding || typeof tenantBranding !== "object") return clientConfig;

  return {
    ...clientConfig,
    branding_config: { ...clientConfig?.branding_config, ...tenantBranding },
    questionnaire_config: { ...clientConfig?.questionnaire_config, ...tenantBranding },
  };
}
